import { render, staticRenderFns } from "./PageView.vue?vue&type=template&id=a5384370&scoped=true&"
import script from "./PageView.vue?vue&type=script&lang=ts&"
export * from "./PageView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5384370",
  null
  
)

export default component.exports